The salary or compensation for a position.
